import { render } from "./ContributionCategoryList.vue?vue&type=template&id=568321a0&scoped=true"
import script from "./ContributionCategoryList.vue?vue&type=script&lang=js"
export * from "./ContributionCategoryList.vue?vue&type=script&lang=js"

import "./ContributionCategoryList.vue?vue&type=style&index=0&id=568321a0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568321a0"]])

export default __exports__